import { getSharedView } from './viewShareSite';

const previews = new Map();
const MAX_AGE = 5 * 60 * 1000;

// A newly mounted ticket or dialog can render the saved introduction in its
// first frame. Refreshing it must never replace readable content with a loader.
export function cachedExhibitionPreview(id) {
  return previews.get(id)?.snapshot || null;
}

// The ticket and exhibition introduction share one request while browsing.
export function loadExhibitionPreview(id) {
  const cached = previews.get(id);
  if (cached && (cached.pending || Date.now() - cached.createdAt < MAX_AGE)) return cached.promise;
  const entry = { createdAt: Date.now(), promise: null, pending: true, snapshot: cached?.snapshot || null };
  entry.promise = getSharedView(id).then(snapshot => {
    entry.snapshot = snapshot;
    entry.pending = false;
    return snapshot;
  }).catch(error => {
    entry.pending = false;
    if (previews.get(id) === entry) {
      if (entry.snapshot) entry.createdAt = 0;
      else previews.delete(id);
    }
    throw error;
  });
  previews.set(id, entry);
  if (previews.size > 16) previews.delete(previews.keys().next().value);
  return entry.promise;
}
